module.exports = __webpack_public_path__ + "img/youtube-empty.4dc18486.svg";